import { axios } from 'api'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import Page from 'components_v2/SupportPages/Main'
import { useCommonEntryContext } from 'components_v2/common'
import { useMeta, useTitle } from 'hooks/useMetaTitle'
export const SUPPORT_DESCRIPTION =
  'If you have an unanswered question, please do not hesitate to contact ALO Wellness Club Support at 323-321-6334 or by email at support@wellnessclub.aloyoga.com.'

const Main = styled.div``
const SupportView = () => {
  const { globalState, setGlobalState } = useCommonEntryContext()
  const props = globalState?.support_list
  useTitle('FAQ')
  useMeta([
    {
      name: 'description',
      content: SUPPORT_DESCRIPTION
    }
  ])
  useEffect(() => {
    if (props) return
    axios
      .get('/support/list')
      .then((res) => {
        setGlobalState('support_list', res.data?.list)
      })
      .catch((err) => console.log(err))
  }, [setGlobalState, props])
  if (!props) return null
  return (
    <Main>
      <Page categoryList={props} />
    </Main>
  )
}

export default SupportView
